import { Flex, LabelWrapper, Select, Text } from "@theorgchartdev/storybook";
import EditableItemGroup from "@/appComponents/Blocks/Utils/EditableItemGroup/EditableItemGroup";
import { GetValuesForField } from "@/Utils/Promises";
import { useEffect, useState } from "react";
import { FieldSelectListProps } from "@/Utils/ComponentLib";
import { appstr } from "@coreapp/utils/appstr";

export const FieldValueGroup = ({
  onChange,
  field,
  value,
  className,
  onRemove,
  fieldOptions,
  dataTestIdPrefix
}) => {
  const [fieldValues, setFieldValues] = useState([]);

  let isValueList = Array.isArray(value);

  let fieldValue = value;
  if (!Array.isArray(fieldValue)) fieldValue = [value];

  let fieldLabel = appstr("Field");
  if (field === "_branchlevel") fieldLabel = appstr("Mode");

  const GetFieldValues = async () => {
    const data = await GetValuesForField(field);
    setFieldValues(data.results);
  };

  useEffect(() => {
    if (field !== "_branchlevel") GetFieldValues();
  }, []);

  const handleValuePickerClick = option => {
    onChange({ field: field, value: option.value, index: option.index });
  };

  const GetValueOptions = index => {
    let valueIndex = isValueList ? index : null;
    let options = [];
    let addSelfOption = fieldValue.indexOf("_self") === index || fieldValue.indexOf("_self") === -1;
    if (addSelfOption) {
      options.push({
        value: "_self",
        label: appstr("User Value"),
        index: valueIndex,
        clickHandler: handleValuePickerClick
      });
    }
    let valueOptions = fieldValues;
    if (field === "_branchlevel") valueOptions = ["self+subordinates"];
    if (fieldValues?.length === 0 && !addSelfOption) valueOptions = fieldValue;
    let addDivider = addSelfOption;
    let selectedValues = isValueList ? fieldValue.filter((v, i) => i !== index) : [];
    for (let value of valueOptions) {
      if (selectedValues.includes(value)) continue;
      let valueOption = {};
      if (addDivider) {
        valueOption.divider = true;
        addDivider = false;
      }
      valueOption.label = value;
      valueOption.index = valueIndex;
      valueOption.clickHandler = handleValuePickerClick;
      valueOption.value = value;
      valueOption.dataTestId = `${dataTestIdPrefix}value-option-${value}`;
      options.push(valueOption);
    }

    return options;
  };
  return (
    <Flex gap={"4px"} width={"100%"}>
      <div style={{ width: "50%" }}>
        <Select
          listProps={FieldSelectListProps()}
          inputOnly={false}
          value={field === "_branchlevel" ? field : `${className}::${field}`}
          placeholder={appstr("selectf")}
          tooltipProps={
            field === "_branchlevel"
              ? { message: appstr("Branch level info"), position: "top-start" }
              : undefined
          }
          label={fieldLabel}
          options={fieldOptions}
          dataTestId={`${dataTestIdPrefix}select`}
        />
      </div>
      <div style={{ width: "50%", flex: 1 }}>
        <LabelWrapper label={appstr("Value")} compact>
          <Flex direction={"column"} gap={"4px"}>
            {fieldValue.map((item, index) => (
              <EditableItemGroup
                key={index}
                visible="hover"
                actions={
                  isValueList && fieldValue.length > 1
                    ? [
                        {
                          iconName: "trash-can",
                          iconProps: { color: "error" },
                          tooltipProps: {
                            message: appstr("Remove value from field"),
                            position: "right"
                          },
                          onClick: () => {
                            onRemove(field, index);
                          }
                        }
                      ]
                    : []
                }
                buttonsInHierarchy
              >
                <div style={{ width: "100%" }}>
                  <Select
                    listProps={FieldSelectListProps()}
                    inputOnly
                    value={item}
                    disabled={field === "_branchlevel"}
                    placeholder={appstr("Select value")}
                    tooltipProps={
                      item === "_self"
                        ? { message: appstr("Self level info"), position: "top-start" }
                        : undefined
                    }
                    popoverProps={{ onOpen: GetFieldValues }}
                    options={GetValueOptions(index)}
                    dataTestId={`${dataTestIdPrefix}value-${index}`}
                  />
                </div>
              </EditableItemGroup>
            ))}
          </Flex>
        </LabelWrapper>
      </div>
    </Flex>
  );
};
